import { uniq } from 'lodash-es';

import type { ChartUnit } from '../../core/types/chart-unit.js';
import type { TimeseriesPerVariant } from '../types/timeseries.js';
import { useYAxisConfig } from './useYAxisConfig.js';

function getAllUnits(data: TimeseriesPerVariant) {
  return uniq(
    data.shapePriority.flatMap((v) => data[v]?.map((s) => s.unit)),
  ) as ChartUnit[];
}

export function useDataByYAxis(
  data: TimeseriesPerVariant,
): TimeseriesPerVariant {
  const yAxis = useYAxisConfig();
  const allUnits = getAllUnits(data);
  const hasAnyAxisDefined = yAxis.left || yAxis.right;
  const hasOnlyOneAxisDefined = !yAxis.left || !yAxis.right;
  const shouldFilterData =
    allUnits.length > 1 && hasOnlyOneAxisDefined && hasAnyAxisDefined;

  if (shouldFilterData) {
    const [firstUnit] = allUnits;

    return {
      line: data.line.filter((series) => series.unit === firstUnit),
      bar: data.bar.filter((series) => series.unit === firstUnit),
      area: data.area.filter((series) => series.unit === firstUnit),
      band: data.band.filter((series) => series.unit === firstUnit),
      shapePriority: data.shapePriority,
    };
  }

  return data;
}
